import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Common/CustomColor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ScrollToTop/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-modal-video/css/modal-video.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/global.css");
